import _defineProperty from '@babel/runtime/helpers/defineProperty';

var agent = {
  AFREECATV_APP_AGENT: 'Afreeca API',
  AFREECATV_WEBVIEW_AGENT: 'Afreeca Webview',
  SOOPLIVE_APP_AGENT: 'Sooplive API',
  SOOPLIVE_WEBVIEW_AGENT: 'Sooplive Webview'
};

var cookie = {
  TICKET_COOKIE_NAME: 'AuthTicket',
  BBS_COOKIE_NAME: 'BbsTicket',
  USER_COOKIE_NAME: 'UserTicket',
  SAVETICKET_COOKIE_NAME: 'BbsSaveTicket',
  ADULTCHECK_COOKIE_NAME: 'AdultCheckedPass'
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NodeEnvType;
(function (NodeEnvType) {
  NodeEnvType["TEST"] = "test";
  NodeEnvType["DEVELOPMENT"] = "development";
  NodeEnvType["BETA"] = "beta";
  NodeEnvType["STAGING"] = "staging";
  NodeEnvType["PRODUCTION"] = "production";
})(NodeEnvType || (NodeEnvType = {}));
var hostGenerator = function hostGenerator(_ref) {
  var environment = _ref.environment,
    _ref$currentProtocol = _ref.currentProtocol,
    currentProtocol = _ref$currentProtocol === void 0 ? 'https:' : _ref$currentProtocol,
    _ref$hostname = _ref.hostname,
    hostname = _ref$hostname === void 0 ? '' : _ref$hostname;
  switch (environment) {
    case NodeEnvType.DEVELOPMENT:
    case NodeEnvType.BETA:
    case NodeEnvType.STAGING:
    case NodeEnvType.TEST:
      return developmentDomain(currentProtocol, hostname);
    case NodeEnvType.PRODUCTION:
      return productionDomain(currentProtocol, hostname);
  }
};
var commonDomains = function commonDomains(protocol, hostname) {
  var AFREECA_ROOT_DOMAIN = 'afreeca.com';
  var AFREECATV_ROOT_DOMAIN = 'afreecatv.com'; //아프리카TV 1차 도메인 (rewrite 로직에서 사용될, 호출 도메인에 따라 값이 변경되면 안되는 항목임)
  var SOOPLIVE_ROOT_DOMAIN = 'sooplive.co.kr'; //SOOP 1차 도메인 (rewrite 로직에서 사용될, 호출 도메인에 따라 값이 변경되면 안되는 항목)
  var SERVICE_ROOT_DOMAIN = 'sooplive.co.kr'; //서비스 최상위 도메인 (호출 주소에 따라 달라지지 않는, 서비스 고정
  // const DOMAIN_CHECK_REGEX = /([a-z0-9\-_]+)*\.[a-z]{2,6}$/;
  var DOMAIN_CHECK_REGEX = /([a-z0-9\-_]+)*\.[a-z]{2,6}$/;
  var DOMAIN = SERVICE_ROOT_DOMAIN;
  if (DOMAIN_CHECK_REGEX.test(hostname)) {
    var DOMAIN_CHECK_RESULT = hostname.match(DOMAIN_CHECK_REGEX);
    if ((DOMAIN_CHECK_RESULT === null || DOMAIN_CHECK_RESULT === void 0 ? void 0 : DOMAIN_CHECK_RESULT[0]) === AFREECATV_ROOT_DOMAIN || (DOMAIN_CHECK_RESULT === null || DOMAIN_CHECK_RESULT === void 0 ? void 0 : DOMAIN_CHECK_RESULT[0]) === 'ext-' + AFREECATV_ROOT_DOMAIN) {
      DOMAIN = AFREECATV_ROOT_DOMAIN;
    } else if ((DOMAIN_CHECK_RESULT === null || DOMAIN_CHECK_RESULT === void 0 ? void 0 : DOMAIN_CHECK_RESULT[0]) === AFREECA_ROOT_DOMAIN) {
      DOMAIN = AFREECA_ROOT_DOMAIN;
    }
  }
  return {
    DOMAIN: DOMAIN,
    AFREECATV_ROOT_DOMAIN: AFREECATV_ROOT_DOMAIN,
    SOOPLIVE_ROOT_DOMAIN: SOOPLIVE_ROOT_DOMAIN,
    SERVICE_ROOT_DOMAIN: SERVICE_ROOT_DOMAIN,
    /**
     * 신규 도메인 정리하는 부분(아래부분부터)
     */
    RES_AFREECATV: "".concat(protocol, "//res.").concat(SERVICE_ROOT_DOMAIN),
    STATIC_AFREECATV: "".concat(protocol, "//static.").concat(SERVICE_ROOT_DOMAIN),
    LIVEIMG_AFREECATV: "".concat(protocol, "//liveimg.").concat(SERVICE_ROOT_DOMAIN),
    ADMIN_IMG_AFREECATV: "".concat(protocol, "//admin.img.").concat(SERVICE_ROOT_DOMAIN),
    STATIC_FILE_AFREECATV: "".concat(protocol, "//static.file.").concat(SERVICE_ROOT_DOMAIN),
    STIMG_AFREECATV: "".concat(protocol, "//stimg.").concat(SERVICE_ROOT_DOMAIN),
    EVENT_IMG_AFREECATV: "".concat(protocol, "//event.img.").concat(SERVICE_ROOT_DOMAIN),
    SPORTS_IMG_AFREECATV: "".concat(protocol, "//sports.img.").concat(SERVICE_ROOT_DOMAIN),
    BBS_IMG_AFREECATV: "".concat(protocol, "//bbs.img.").concat(SERVICE_ROOT_DOMAIN),
    FFOM_IMG_AFREECATV: "".concat(protocol, "//ffom.img.").concat(SERVICE_ROOT_DOMAIN),
    VR_IMG_AFREECATV: "".concat(protocol, "//vr.img.").concat(SERVICE_ROOT_DOMAIN),
    PROFILE_IMG_AFREECATV: "".concat(protocol, "//profile.img.").concat(SERVICE_ROOT_DOMAIN),
    ADMIN_AFREECATV: "".concat(protocol, "//admin.").concat(SERVICE_ROOT_DOMAIN),
    M_AFREECATV: "".concat(protocol, "//m.").concat(SERVICE_ROOT_DOMAIN),
    API_M_AFREECATV: "".concat(protocol, "//api.m.").concat(SERVICE_ROOT_DOMAIN),
    STATIC_M_AFREECATV: "".concat(protocol, "//static.m.").concat(SERVICE_ROOT_DOMAIN),
    CACHE_M_AFREECATV: "".concat(protocol, "//cache.m.").concat(SERVICE_ROOT_DOMAIN),
    ITEM_M_AFREECATV: "https://item.m.".concat(SERVICE_ROOT_DOMAIN),
    AUTH_M_AFREECATV: "https://auth.m.".concat(SERVICE_ROOT_DOMAIN),
    MEMBER_M_AFREECATV: "https://member.m.".concat(SERVICE_ROOT_DOMAIN),
    WWW_AFREECATV: "".concat(protocol, "//www.").concat(SERVICE_ROOT_DOMAIN),
    SPORTSTV_AFREECATV: "".concat(protocol, "//sportstv.").concat(SERVICE_ROOT_DOMAIN),
    LIVE_AFREECATV: "".concat(protocol, "//live.").concat(SERVICE_ROOT_DOMAIN),
    AFWBBS1_AFREECATV: "".concat(protocol, "//afwbbs1.").concat(SERVICE_ROOT_DOMAIN),
    BJ_AFREECATV: "".concat(protocol, "//ch.").concat(SERVICE_ROOT_DOMAIN),
    OPENTV_AFREECATV: "".concat(protocol, "//opentv.").concat(SERVICE_ROOT_DOMAIN),
    POINT_AFREECATV: "https://point.".concat(SERVICE_ROOT_DOMAIN),
    POINTAPI_AFREECATV: "".concat(protocol, "//pointapi.").concat(SERVICE_ROOT_DOMAIN),
    HELP_AFREECATV: "".concat(protocol, "//help.").concat(SERVICE_ROOT_DOMAIN),
    GHELP_AFREECATV: "".concat(protocol, "//ghelp.").concat(SERVICE_ROOT_DOMAIN),
    APIHELP_AFREECATV: "".concat(protocol, "//apihelp.").concat(SERVICE_ROOT_DOMAIN),
    ST_AFREECATV: "".concat(protocol, "//st.").concat(SERVICE_ROOT_DOMAIN),
    STBBS_AFREECATV: "".concat(protocol, "//stbbs.").concat(SERVICE_ROOT_DOMAIN),
    AFEVENT_AFREECATV: "".concat(protocol, "//afevent.").concat(SERVICE_ROOT_DOMAIN),
    AFEVENT2_AFREECATV: "".concat(protocol, "//afevent2.").concat(SERVICE_ROOT_DOMAIN),
    LOGIN_AFREECATV: "https://login.".concat(SERVICE_ROOT_DOMAIN),
    AFUPD1_AFREECATV: "".concat(protocol, "//afupd1.").concat(SERVICE_ROOT_DOMAIN),
    AFUPDJP_AFREECATV: "".concat(protocol, "//afupdjp.").concat(SERVICE_ROOT_DOMAIN),
    MEMBER_AFREECATV: "https://member.".concat(SERVICE_ROOT_DOMAIN),
    NOTE_AFREECATV: "".concat(protocol, "//note.").concat(SERVICE_ROOT_DOMAIN),
    UPDATE_AFREECATV: "".concat(protocol, "//update.").concat(SERVICE_ROOT_DOMAIN),
    PLAY_AFREECATV: "".concat(protocol, "//play.").concat(SERVICE_ROOT_DOMAIN),
    ADREVENUE_AFREECATV: "".concat(protocol, "//adrevenue.").concat(SERVICE_ROOT_DOMAIN),
    APISABANA_AFREECATV: "https://apisabana.".concat(SERVICE_ROOT_DOMAIN),
    AFJOBENC1_AFREECATV: "".concat(protocol, "//afjobenc1.").concat(SERVICE_ROOT_DOMAIN),
    SPORTS_AFREECATV: "".concat(protocol, "//sports.").concat(SERVICE_ROOT_DOMAIN),
    SBS_AFREECATV: "".concat(protocol, "//sbs.").concat(SERVICE_ROOT_DOMAIN),
    API_SPORTS_AFREECATV: "".concat(protocol, "//api.sports.").concat(SERVICE_ROOT_DOMAIN),
    VR_AFREECATV: "".concat(protocol, "//vr.").concat(SERVICE_ROOT_DOMAIN),
    ANI_AFREECATV: "".concat(protocol, "//ani.").concat(SERVICE_ROOT_DOMAIN),
    TV_AFREECATV: "".concat(protocol, "//tv.").concat(SERVICE_ROOT_DOMAIN),
    STAR_AFREECATV: "".concat(protocol, "//star.").concat(SERVICE_ROOT_DOMAIN),
    ANALYSIS_AFREECATV: "".concat(protocol, "//analysis.").concat(SERVICE_ROOT_DOMAIN),
    FFOM_AFREECATV: "".concat(protocol, "//ffom.").concat(SERVICE_ROOT_DOMAIN),
    SHOP_AFREECATV: "".concat(protocol, "//sooptore.").concat(SERVICE_ROOT_DOMAIN),
    SHOPFREECA_AFREECATV: "".concat(protocol, "//sooptore.").concat(SERVICE_ROOT_DOMAIN),
    ADTIME_AFREECATV: "".concat(protocol, "//adtime.").concat(SERVICE_ROOT_DOMAIN),
    ADBALLOON_AFREECATV: "".concat(protocol, "//adballoon.").concat(SERVICE_ROOT_DOMAIN),
    UP_AFREECATV: "".concat(protocol, "//up.").concat(SERVICE_ROOT_DOMAIN),
    ITEM_AFREECATV: "".concat(protocol, "//item.").concat(SERVICE_ROOT_DOMAIN),
    TOKEN_AFREECATV: "".concat(protocol, "//token.").concat(SERVICE_ROOT_DOMAIN),
    ITEMS_AFREECATV: "".concat(protocol, "//items.").concat(SERVICE_ROOT_DOMAIN),
    INFODESK_AFREECATV: "".concat(protocol, "//infodesk.").concat(SERVICE_ROOT_DOMAIN),
    BJGUIDE_AFREECATV: "".concat(protocol, "//bjguide.").concat(SERVICE_ROOT_DOMAIN),
    DASHBOARD_AFREECATV: "".concat(protocol, "//dashboard.").concat(SERVICE_ROOT_DOMAIN),
    SUBS_AFREECATV: "".concat(protocol, "//subs.").concat(SERVICE_ROOT_DOMAIN),
    NEWBJ_AFREECATV: "".concat(protocol, "//newbj.").concat(SERVICE_ROOT_DOMAIN),
    FREECAP_AFREECATV: "".concat(protocol, "//apro.").concat(SERVICE_ROOT_DOMAIN),
    STATIC_FREECAP_AFREECATV: "".concat(protocol, "//static.apro.").concat(SERVICE_ROOT_DOMAIN),
    BBS_FREECAP_AFREECATV: "".concat(protocol, "//bbs.apro.").concat(SERVICE_ROOT_DOMAIN),
    GAMECENTERPC_AFREECATV: "".concat(protocol, "//gamecenterpc.").concat(SERVICE_ROOT_DOMAIN),
    CONTENTLAB_AFREECATV: "".concat(protocol, "//contentlab.").concat(SERVICE_ROOT_DOMAIN),
    WWW_BIZAFREECATV: "".concat(protocol, "//www.bizafreeca.com"),
    GAMETV_AFREECATV: "".concat(protocol, "//esports.").concat(SERVICE_ROOT_DOMAIN),
    BORA_AFREECATV: "".concat(protocol, "//bora.").concat(SERVICE_ROOT_DOMAIN),
    BESTBJ_AFREECATV: "".concat(protocol, "//bestbj.").concat(SERVICE_ROOT_DOMAIN),
    ISSUE_AFREECATV: "".concat(protocol, "//issue.").concat(SERVICE_ROOT_DOMAIN),
    AD_AFREECATV: "".concat(protocol, "//ad.").concat(SERVICE_ROOT_DOMAIN),
    PA_AFREECATV: "".concat(protocol, "//pa.").concat(SERVICE_ROOT_DOMAIN),
    VOD_AFREECATV: "".concat(protocol, "//vod.").concat(SERVICE_ROOT_DOMAIN),
    VIDEO_AFREECATV: "".concat(protocol, "//video.").concat(SERVICE_ROOT_DOMAIN),
    HLS_AFREECATV: "".concat(protocol, "//hls.").concat(SERVICE_ROOT_DOMAIN),
    HLS_STAGE_AFREECATV: "".concat(protocol, "//hls-stage.").concat(SERVICE_ROOT_DOMAIN),
    VIDEOIMG_AFREECATV: "".concat(protocol, "//videoimg.").concat(SERVICE_ROOT_DOMAIN),
    VIDEOIMG_TEST_AFREECATV: "".concat(protocol, "//videoimg-test.").concat(SERVICE_ROOT_DOMAIN),
    TS_PC_STREAM_AFREECATV: "".concat(protocol, "//ts-pc.stream.").concat(SERVICE_ROOT_DOMAIN),
    AFREECATV_ASYNC_WISEN_GSCDN: "".concat(protocol, "//afreecatv.async.wisen.gscdn.com"),
    AFFLV_AFREECATV: "".concat(protocol, "//afflv14.").concat(SERVICE_ROOT_DOMAIN),
    AQUA_AFREECATV: "".concat(protocol, "//aqua.").concat(SERVICE_ROOT_DOMAIN),
    BROADSTATISTIC_AFREECATV: "".concat(protocol, "//broadstatistic.").concat(SERVICE_ROOT_DOMAIN),
    SCH_AFREECATV: "".concat(protocol, "//sch.").concat(SERVICE_ROOT_DOMAIN),
    SCKETC_AFREECATV: "".concat(protocol, "//scketc.").concat(SERVICE_ROOT_DOMAIN),
    V_AFREE_CA: 'https://v.afree.ca',
    TRANSCODER_AFREECATV: "".concat(protocol, "//transcoder.").concat(SERVICE_ROOT_DOMAIN),
    VACSDRDB_AFREECATV: "".concat(protocol, "//vacsdrdb.").concat(SERVICE_ROOT_DOMAIN),
    EVENTAPI_AFREECATV: "".concat(protocol, "//eventapi.").concat(SERVICE_ROOT_DOMAIN),
    API_UP_AFREECATV: "".concat(protocol, "//api.up.").concat(SERVICE_ROOT_DOMAIN),
    STUDIO_AFREECATV: "".concat(protocol, "//studio.").concat(SERVICE_ROOT_DOMAIN),
    SOTONG_AFREECATV: "".concat(protocol, "//sotong.").concat(SERVICE_ROOT_DOMAIN),
    NEWAPPLY_AFREECATV: "".concat(protocol, "//newapply.").concat(SERVICE_ROOT_DOMAIN),
    MYPOINT_AFREECATV: "".concat(protocol, "//mypoint.").concat(SERVICE_ROOT_DOMAIN),
    VEDITOR_AFREECATV: "".concat(protocol, "//veditor.").concat(SERVICE_ROOT_DOMAIN),
    DEVELOPERS_AFREECATV: "".concat(protocol, "//developers.").concat(SERVICE_ROOT_DOMAIN),
    MYREVENUE_AFREECATV: "".concat(protocol, "//myrevenue.").concat(SERVICE_ROOT_DOMAIN),
    OGQ_MARKET_AFREECATV: "".concat(protocol, "//ogqmarket.").concat(SERVICE_ROOT_DOMAIN),
    OGQ_IMG_AFREECATV: "".concat(protocol, "//ogq-sticker-global-cdn-z01.").concat(SERVICE_ROOT_DOMAIN),
    OGQ_IMG_TEST_AFREECATV: "".concat(protocol, "//ogqmarket.img.").concat(SERVICE_ROOT_DOMAIN),
    ESPORTS_AFREECATV: "".concat(protocol, "//esports.").concat(SERVICE_ROOT_DOMAIN),
    AFREECACOLOSSEUM: "".concat(protocol, "//www.afreecacolosseum.com"),
    MY_AFREECATV: "".concat(protocol, "//my.").concat(SERVICE_ROOT_DOMAIN),
    PPV_AFREECATV: "".concat(protocol, "//ppv.").concat(SERVICE_ROOT_DOMAIN),
    DDUKBOB_AFREECATV: "".concat(protocol, "//suggest.").concat(SERVICE_ROOT_DOMAIN),
    TOKENAPI_AFREECATV: "https://tokenapi.".concat(SERVICE_ROOT_DOMAIN),
    ADPAPI_AFREECATV: "".concat(protocol, "//adpapi.").concat(SERVICE_ROOT_DOMAIN),
    OLYMPIC_AFREECATV: "".concat(protocol, "//olympic.").concat(SERVICE_ROOT_DOMAIN),
    BJ_MATCH_AFREECATV: "".concat(protocol, "//bjmatch.").concat(SERVICE_ROOT_DOMAIN),
    VODBJ_AFREECATV: "".concat(protocol, "//vodbj.").concat(SERVICE_ROOT_DOMAIN),
    BJ_EDU_AFREECATV: "".concat(protocol, "//bjedu.").concat(SERVICE_ROOT_DOMAIN),
    THEATER_AFREECATV: "".concat(protocol, "//theater.").concat(SERVICE_ROOT_DOMAIN),
    AFTMARKET_TV: "".concat(protocol, "//aftmarket.tv"),
    EXTENSION_AFREECATV: "".concat(protocol, "//extension.").concat(SERVICE_ROOT_DOMAIN),
    EXTENSION_FILE_AFREECATV: "".concat(protocol, "//extfileupload.").concat(SERVICE_ROOT_DOMAIN),
    NOTI_AFREECATV: "".concat(protocol, "//noti.").concat(SERVICE_ROOT_DOMAIN),
    GEM_ADMIN_AFREECATV: "https://esadmin.".concat(SERVICE_ROOT_DOMAIN),
    GEM_API_AFREECATV: "".concat(protocol, "//gpapi.").concat(SERVICE_ROOT_DOMAIN),
    PARTNERSHIP_AFREECATV: "".concat(protocol, "//partnership.").concat(SERVICE_ROOT_DOMAIN),
    CREATOR_UP_AFREECATV: "".concat(protocol, "//creatorup.").concat(SERVICE_ROOT_DOMAIN),
    ITEM_API_AFREECATV: "".concat(protocol, "//item-api.").concat(SERVICE_ROOT_DOMAIN),
    ITEM_API_TEST_AFREECATV: "".concat(protocol, "//item-api-test.").concat(SERVICE_ROOT_DOMAIN),
    ITEM_ADMIN_AFREECATV: "https://item-admin.".concat(SERVICE_ROOT_DOMAIN, ":8001"),
    ITEM_ADMIN_TEST_AFREECATV: "https://item-admin-test.".concat(SERVICE_ROOT_DOMAIN, ":8001"),
    DOLRIMPAN_AFREECATV: "".concat(protocol, "//dolrimpan.").concat(SERVICE_ROOT_DOMAIN),
    BILLIARDS_AFREECATV: "".concat(protocol, "//billiards.").concat(SERVICE_ROOT_DOMAIN),
    CINETY_AFREECATV: "".concat(protocol, "//cinety.").concat(SERVICE_ROOT_DOMAIN),
    DEAPI_AD_AFREECATV: "".concat(protocol, "//deapi.").concat(SERVICE_ROOT_DOMAIN),
    DEAPIDEV_AD_AFREECATV: "".concat(protocol, "//deapidev.").concat(SERVICE_ROOT_DOMAIN),
    SAYBUZZ_AD_URL: "".concat(protocol, "//ad.saybuzz.io"),
    SAYBUZZ_ITEM_URL: "".concat(protocol, "//item.saybuzz.io"),
    SAYBUZZ_URL: "".concat(protocol, "//www.saybuzz.io"),
    SAYBUZZ_ABOUT_URL: "".concat(protocol, "//about.saybuzz.io"),
    AWARD_AFREECATV: "".concat(protocol, "//award.").concat(SERVICE_ROOT_DOMAIN),
    ADV_AFREECATV: "".concat(protocol, "//adv.").concat(SERVICE_ROOT_DOMAIN),
    SPORTSISSUE_AFREECATV: "https://sportsissue.".concat(SERVICE_ROOT_DOMAIN),
    STARRANK_AFREECATV: "https://starrank.".concat(SERVICE_ROOT_DOMAIN),
    CORP_AFREECATV: "https://corp.".concat(SERVICE_ROOT_DOMAIN),
    RECRUIT_AFREECATV: "https://recruit.".concat(SERVICE_ROOT_DOMAIN),
    FORM_AFREECATV: "".concat(protocol, "//form.").concat(SERVICE_ROOT_DOMAIN),
    OPENAPI_AFREECATV: "".concat(protocol, "//openapi.").concat(SERVICE_ROOT_DOMAIN),
    TKAPI_AFREECATV: "".concat(protocol, "//tkapi.").concat(SERVICE_ROOT_DOMAIN),
    AUTOPAY_FREE_AFREECATV: "".concat(protocol, "//autopay-free.").concat(SERVICE_ROOT_DOMAIN),
    ATVAPI_AFREECATV: "".concat(protocol, "//atvapi.").concat(SERVICE_ROOT_DOMAIN),
    GFL_AFREECATV: "".concat(protocol, "//gfl.").concat(SERVICE_ROOT_DOMAIN),
    LINK_AFREECATV: "https://link.".concat(SERVICE_ROOT_DOMAIN),
    ENTRYSTATIC_AFREECATV: "https://entrystatic.".concat(SERVICE_ROOT_DOMAIN),
    BJAPI_AFREECATV: "https://chapi.".concat(SERVICE_ROOT_DOMAIN),
    SHOP_IMG_AFREECATV: "https://shop.img.".concat(SERVICE_ROOT_DOMAIN),
    SLUGGER_AFREECATV: "https://slugger.".concat(SERVICE_ROOT_DOMAIN),
    GAMERANKING_AFREECATV: "https://gameranking.".concat(SERVICE_ROOT_DOMAIN),
    GEM_AFREECATV: "".concat(protocol, "//gem.").concat(SERVICE_ROOT_DOMAIN),
    PARTNERBJ_AFREECATV: "".concat(protocol, "//partnerbj.").concat(SERVICE_ROOT_DOMAIN),
    SUPPORTERS_AFREECATV: "".concat(protocol, "//supporters.").concat(SERVICE_ROOT_DOMAIN),
    VOTE_AFREECATV: "".concat(protocol, "//vote.").concat(SERVICE_ROOT_DOMAIN),
    MYAPI_AFREECATV: "".concat(protocol, "//myapi.").concat(SERVICE_ROOT_DOMAIN),
    STS_FREECAP_AFREECATV: "".concat(protocol, "//cappy.").concat(SERVICE_ROOT_DOMAIN),
    GGGL_API_AFREECATV: "".concat(protocol, "//ggglapi.").concat(SERVICE_ROOT_DOMAIN),
    EXTENSION_DEPLOY_UPLOAD_AFREECATV: "".concat(protocol, "//file.ext-").concat(SERVICE_ROOT_DOMAIN),
    DROPS_AFREECATV: "".concat(protocol, "//drops.").concat(SERVICE_ROOT_DOMAIN)
  };
};
var developmentDomain = function developmentDomain(protocol, hostname) {
  return _objectSpread({}, commonDomains(protocol, hostname));
};
var productionDomain = function productionDomain(protocol, hostname) {
  return _objectSpread({}, commonDomains(protocol, hostname));
};

var scheme = {
  AFREECATV_APP_SCHEME: 'afreeca://',
  SOOPLIVE_APP_SCHEME: 'sooplive://',
  SERVICE_APP_SCHEME: 'sooplive://'
};

export { agent, cookie, hostGenerator, scheme };
//# sourceMappingURL=index.js.map
